import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { LifestyleService } from 'src/app/services/ha-new/lifestyle.service';
import { SpinnerComponent } from 'src/app/modules/shared/spinner/spinner.component';
import { ActivatedRoute } from '@angular/router';
import { NewHAService } from 'src/app/services/ha-new/new-ha.service';

@Component({
	selector: 'app-how-you-eat',
	templateUrl: './how-you-eat.component.html',
	styleUrls: ['./how-you-eat.component.scss'],
})
export class HowYouEatComponent implements OnInit {
	/** Data carrier subscriptions */
	subscriptions: Subscription[] = [];
	/** holds ha id */
	healthAssessmentID: number = 0;
	/** holds appointment id */
	apptID: any;
	/** holds readOnly flag */
	readOnly: boolean = false;
	howYouEatData: any = {};

	howYouEatForm: FormGroup;
	scrollTo = '';
	returningUser: boolean = false;

	constructor(
		private lifestyleService: LifestyleService,
		private spinner: SpinnerComponent,
		private activatedRoute: ActivatedRoute,
		private haService: NewHAService
	) {
		this.activatedRoute.queryParams.subscribe(params => {
			//console.log('params:', params);
			this.apptID = params.apptID;
			this.readOnly = params.readOnly === 'true';
			this.healthAssessmentID = params.healthAssessmentID;
			this.returningUser = params.returningUser === 'true';
			if (this.scrollTo != 'false') {
				this.scrollTo = params.section;
			}
		});
	}

	ngOnInit() {
		this.initializeHowYouEatForm();
		this.getHowYouEat();
	}
	next() {
		if (!this.readOnly) {
			if (this.howYouEatForm.valid) {
				this.saveHowYouEat();
			}
		}
	}

	getHowYouEat() {
		this.spinner.startLoader();
		this.subscriptions.push(
			this.lifestyleService.getHowYouEat(this.apptID, this.healthAssessmentID).subscribe(
				response => {
					this.spinner.stopLoader();
					this.howYouEatData = response.data;
					//console.log(this.howYouEatData)

					this.howYouEatForm.controls.servingsOfFruitsVegetables.setValue(
						this.howYouEatData.servingsOfFruitsVegetables
					);
					this.howYouEatForm.controls.howManyFastSugaryFood.setValue(this.howYouEatData.howManyFastSugaryFood);
					this.howYouEatForm.controls.followedAnyDiets.setValue(this.howYouEatData.followedAnyDiets);
					this.howYouEatForm.controls.dietDetails.setValue(this.howYouEatData.dietDetails);

					//console.log(this.howYouEatForm)

					if (this.scrollTo != 'false') {
						if (this.haService.scrollView(this.scrollTo)) {
							this.scrollTo = 'false';
						}
					}
				},
				err => {
					this.spinner.stopLoader();
					console.log(err);
				}
			)
		);
	}

	/**
	 * saves safety
	 */
	saveHowYouEat() {
		if (!this.howYouEatForm.controls.followedAnyDiets.value) {
			this.howYouEatForm.controls.dietDetails.setValue('');
		}
		this.subscriptions.push(
			this.lifestyleService
				.saveHowYouEat(this.apptID, {
					...this.howYouEatForm.getRawValue(),
					healthAssessmentID: this.howYouEatData.healthAssessmentID,
				})
				.subscribe(
					res => {
						//console.log(res);
						this.haService.redirect(
							[],
							[],
							['how-you-move'],
							this.apptID,
							this.healthAssessmentID,
							this.readOnly,
							'lifestyle-how-you-move',
							this.returningUser
						);
					},
					err => {
						console.log(err);
					}
				)
		);
	}

	initializeHowYouEatForm() {
		this.howYouEatForm = new FormGroup({
			servingsOfFruitsVegetables: new FormControl(''),
			howManyFastSugaryFood: new FormControl(''),
			followedAnyDiets: new FormControl(''),
			dietDetails: new FormControl(''),
		});
	}
}
